import sampleImage1 from "../../styles/images/samples/sample_5.jpg";
import { ReactElement } from "react";
import { env } from "env";
import {
  getLocalStorageAccessToken,
  getLocalStorageItem,
  getLocalStorageRefreshToken,
  removeLocalStorageAccessToken,
  removeLocalStorageRefreshToken,
  setLocalStorageAccessToken,
  setLocalStorageRefreshToken,
} from "./localStorage";

export const getBackgroundImage = (code: string) => {
  switch (code) {
    case "chauffage":
      return "https://groupe-atlantic.cache.ephoto.fr/link/3c9igq/tur1bsh3ktjyogw.jpg";
    case "ecs":
      return "https://groupe-atlantic.cache.ephoto.fr/link/3c9igq/msx1bsh3ktmeio0.jpg";
    case "chauffage-ecs":
      return "https://groupe-atlantic.cache.ephoto.fr/link/3c9igq/mnl1bsh3ktrgtuo.jpg";
    default:
      return sampleImage1;
  }
};

export const getIcons = (code: string): ReactElement => {
  switch (code) {
    case "ecs":
      return <icon data-icon-size="48">water_drop</icon>;
    case "chauffage-ecs":
      return (
        <>
          <icon data-icon-size="24">water_drop</icon>
          <icon data-icon-size="24">heat</icon>
        </>
      );
    default:
      return <icon data-icon-size="48">heat</icon>;
  }
};

let appToken: string;
let appTokenExpire: number;
let isLoadingAppToken: boolean = false;

export const getMemAppToken = (): string => {
  return appToken;
};

export const setMemAppToken = (token: string) => {
  appToken = token;
  isLoadingAppToken = false;
  appTokenExpire = Date.now() + 10 * 1000;
};

const getUniversByUrl = () => {
  let univers = "atlantic";
  const paths = location.pathname.split("/").filter((el) => el != "");
  if (paths?.length > 0) {
    switch (paths[0]) {
      case "ACVFR":
      case "ACVES":
      case "ACVUK":
        univers = "acv";
        break;
      default:
        univers = "atlantic";
        break;
    }
  }
  return univers;
};

const app_back_api_url = env.app_token_url;
export const getAppToken = (callback: any, allowLoad: boolean = false) => {
  if (
    (!isLoadingAppToken && (!appTokenExpire || Date.now() > appTokenExpire)) ||
    allowLoad
  ) {
    isLoadingAppToken = true;

    let fd = "grant_type=client_credentials";
    fd += "&univers=" + getUniversByUrl();
    const headers = { "Content-Type": "application/x-www-form-urlencoded" };
    const fetchOptions = {
      method: "POST",
      body: fd,
    };
    const params = {
      ...fetchOptions,
      headers: headers,
    };

    fetch(`${app_back_api_url ?? ""}/api/token`, params as any)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result && result.access_token) {
          //setLocalStorageItem(LOCAL_STORAGE_KEYS.AppToken, result.access_token);
          setMemAppToken(result.access_token);
          callback && callback(appToken);
        } else {
          isLoadingAppToken = false;
        }
      })
      .catch((error) => {
        isLoadingAppToken = false;
        console.log(error);
      });
  } else {
    callback && callback(appToken);
  }

  return null;
};

export const getUserTokenAsync = async () => {
  const user_token = getLocalStorageAccessToken();
  if (user_token) {
    let univers = getUniversByUrl();
    const stateLogin = getLocalStorageItem("loginState");
    try {
      const jsonState = JSON.parse(atob(stateLogin as any));
      if (jsonState.IsInternal) {
        univers = "azure-ad";
      }
    } catch (e) {
      console.log(e);
    }
    const refresh_token = getLocalStorageRefreshToken();
    let fd = "grant_type=refresh_token";
    fd += "&univers=" + univers.replace("-fr", "");
    fd += "&refresh_token=" + refresh_token;
    fd += `&redirect_uri=${window.location.origin}/wso/callback`;

    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
    const fetchOptions = {
      method: "POST",
      body: fd,
    };
    const params = {
      ...fetchOptions,
      headers: headers,
    };

    const response = await fetch(
      `${app_back_api_url ?? ""}/api/token`,
      params as any
    );
    if (response.ok) {
      try {
        const result = await response.json();
        if (result.access_token) {
          setLocalStorageAccessToken(result.access_token);
          setLocalStorageRefreshToken(result.refresh_token);
          return result.access_token;
        } else {
          removeLocalStorageAccessToken();
          removeLocalStorageRefreshToken();
          return null;
        }
      } catch (e) {
        removeLocalStorageAccessToken();
        removeLocalStorageRefreshToken();
        console.log(e);
      }
    } else {
      removeLocalStorageAccessToken();
      removeLocalStorageRefreshToken();
    }
    return null;
  }
};

// Helper to transform code_gamme_pac value as used in api.ts
export function transformCodeGammePac(
  code_gamme_pac?: string[]
): string | undefined {
  return code_gamme_pac?.length === 1 ? code_gamme_pac[0] : "ALL";
}

// Helper to transform appoint value as used in api.ts
export function transformAppoint(appoint?: boolean[]): boolean | undefined {
  return appoint?.length === 1 ? appoint[0] : undefined;
}

export function onScrollGlobal() {
  const elem = document.getElementsByClassName(
    "ant-select-dropdown"
  ) as HTMLCollection;
  if (elem) {
    Array.from(elem).forEach((e: any) => {
      e.classList?.add("ant-select-dropdown-hidden");
    });
  }
}
